import { render } from "./compliance_management.html?vue&type=template&id=2cc110b8&external"
import script from "./compliance_management?vue&type=script&lang=js&external"
export * from "./compliance_management?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__